module.exports = __webpack_public_path__ + "static/img/Advanced-Torso-CT3.cf0ab77e.png";